module.exports = __webpack_public_path__ + "img/echo.55012de0.jpeg";